import { apiInstances } from '../../../../libs';

const { post } = apiInstances.authInstance;

export default function createEncryptPassword({ key, token }) {
  return post(
    `/encrypt-restore`,
    { key },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}
